var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$d = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$c = fails$d;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$c(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$b = fails$d;

var functionBindNative = !fails$b(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$8 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$8.bind(call$8) : function () {
  return call$8.apply(call$8, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var bind = FunctionPrototype$1.bind;
var call$7 = FunctionPrototype$1.call;
var uncurryThis$d = NATIVE_BIND && bind.bind(call$7, call$7);

var functionUncurryThis = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis$d(fn);
} : function (fn) {
  return fn && function () {
    return call$7.apply(fn, arguments);
  };
};

var uncurryThis$c = functionUncurryThis;

var toString$5 = uncurryThis$c({}.toString);
var stringSlice$2 = uncurryThis$c(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$2(toString$5(it), 8, -1);
};

var uncurryThis$b = functionUncurryThis;
var fails$a = fails$d;
var classof$3 = classofRaw$1;

var $Object$3 = Object;
var split = uncurryThis$b(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$3('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$3(it) == 'String' ? split(it, '') : $Object$3(it);
} : $Object$3;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$3 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$2 = isNullOrUndefined$3;

var $TypeError$6 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (isNullOrUndefined$2(it)) throw $TypeError$6("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$4;

var toIndexedObject$4 = function (it) {
  return IndexedObject$1(requireObjectCoercible$3(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$c = function (argument) {
  return typeof argument == 'function';
};

var isCallable$b = isCallable$c;

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var SPECIAL_DOCUMENT_ALL = typeof documentAll == 'undefined' && documentAll !== undefined;

var isObject$5 = SPECIAL_DOCUMENT_ALL ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$b(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$b(it);
};

var global$c = global$d;
var isCallable$a = isCallable$c;

var aFunction = function (argument) {
  return isCallable$a(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var uncurryThis$a = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$a({}.isPrototypeOf);

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process = global$b.process;
var Deno = global$b.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$9 = fails$d;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$4;
var isCallable$9 = isCallable$c;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$9($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$8 = isCallable$c;
var tryToString = tryToString$1;

var $TypeError$5 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$8(argument)) return argument;
  throw $TypeError$5(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;
var isNullOrUndefined$1 = isNullOrUndefined$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$2 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$1(func) ? undefined : aCallable(func);
};

var call$6 = functionCall;
var isCallable$7 = isCallable$c;
var isObject$4 = isObject$5;

var $TypeError$4 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$7(fn = input.toString) && !isObject$4(val = call$6(fn, input))) return val;
  if (isCallable$7(fn = input.valueOf) && !isObject$4(val = call$6(fn, input))) return val;
  if (pref !== 'string' && isCallable$7(fn = input.toString) && !isObject$4(val = call$6(fn, input))) return val;
  throw $TypeError$4("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$a = global$d;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$2(global$a, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$d;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.25.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.25.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$2 = requireObjectCoercible$4;

var $Object$1 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return $Object$1(requireObjectCoercible$2(argument));
};

var uncurryThis$9 = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$9({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$8 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$4 = uncurryThis$8(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$4(++id + postfix, 36);
};

var global$8 = global$d;
var shared$3 = shared$4.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$8.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$4 = function (name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$5 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod$1 = getMethod$2;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$3 = wellKnownSymbol$4;

var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$3('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$1(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$5(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$7 = global$d;
var isObject$2 = isObject$5;

var document$1 = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document$1) && isObject$2(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$8 = descriptors;
var fails$8 = fails$d;
var createElement = documentCreateElement$1;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$8 && !fails$8(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$7 = descriptors;
var call$4 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$7 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call$4(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$6 = descriptors;
var fails$7 = fails$d;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$6 && fails$7(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String$1 = String;
var $TypeError$2 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$7 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$2($String$1(argument) + ' is not an object');
};

var DESCRIPTORS$5 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$6 = anObject$7;
var toPropertyKey = toPropertyKey$2;

var $TypeError$1 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$5 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPropertyKey(P);
  anObject$6(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPropertyKey(P);
  anObject$6(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$4 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$3 = DESCRIPTORS$4 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$3 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$3 || (DESCRIPTORS$3 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$7 = functionUncurryThis;
var isCallable$6 = isCallable$c;
var store$1 = sharedStore;

var functionToString = uncurryThis$7(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$6(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$6 = global$d;
var isCallable$5 = isCallable$c;

var WeakMap$1 = global$6.WeakMap;

var weakMapBasicDetection = isCallable$5(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$2 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$5 = global$d;
var uncurryThis$6 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$3;
var hasOwn$3 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$5.TypeError;
var WeakMap = global$5.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$6(store.get);
  var wmhas = uncurryThis$6(store.has);
  var wmset = uncurryThis$6(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$3(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$6 = fails$d;
var isCallable$4 = isCallable$c;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$2 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState$1 = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$2 && !fails$6(function () {
  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS$2) defineProperty$1(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
    defineProperty$1(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$2) defineProperty$1(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$4(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var isCallable$3 = isCallable$c;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$2 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$3(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$3 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$2(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$5 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$5([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf$1(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var uncurryThis$4 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$5 = anObject$7;

var concat$1 = uncurryThis$4([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$5(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$d;
var isCallable$2 = isCallable$c;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$2(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$4 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$3;
var defineBuiltIn$1 = defineBuiltIn$2;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$4;
  } else if (STATIC) {
    target = global$4[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$4[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    defineBuiltIn$1(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$1 = descriptors;
var uncurryThis$3 = functionUncurryThis;
var call$3 = functionCall;
var fails$4 = fails$d;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$3([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$3(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$1 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$$1({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/**
 * Do not edit directly
 * Generated on Tue, 25 Oct 2022 21:31:24 GMT
 */
const GlobalCommonBlack = '#000000';
const GlobalCommonWhite = '#ffffff';
const GlobalCommonBlack40 = '#00000066';
const GlobalCommonWhite40 = '#ffffff66';
const GlobalGrey100 = '#f5f5f5';
const GlobalGrey200 = '#eeeeee';
const GlobalGrey300 = '#e0e0e0';
const GlobalGrey400 = '#bdbdbd';
const GlobalGrey500 = '#9e9e9e';
const GlobalGrey600 = '#757575';
const GlobalGrey700 = '#616161';
const GlobalGrey800 = '#424242';
const GlobalGrey900 = '#212121';
const GlobalSuccessDarkest = '#223d1d';
const GlobalSuccessDark = '#345c2c';
const GlobalSuccessMain = '#457a3b';
const GlobalSuccessLight = '#66af59';
const GlobalSuccessLightest = '#b2d7ac';
const GlobalErrorDarkest = '#6c140e';
const GlobalErrorDark = '#a21f15';
const GlobalErrorMain = '#da291c';
const GlobalErrorLight = '#ea665d';
const GlobalErrorLightest = '#f3aaa5';

const globalTheme = {
  common: {
    black: GlobalCommonBlack,
    black40: GlobalCommonBlack40,
    white: GlobalCommonWhite,
    white40: GlobalCommonWhite40
  },
  grey: {
    100: GlobalGrey100,
    200: GlobalGrey200,
    300: GlobalGrey300,
    400: GlobalGrey400,
    500: GlobalGrey500,
    600: GlobalGrey600,
    700: GlobalGrey700,
    800: GlobalGrey800,
    900: GlobalGrey900
  },
  success: {
    darkest: GlobalSuccessDarkest,
    dark: GlobalSuccessDark,
    main: GlobalSuccessMain,
    light: GlobalSuccessLight,
    lightest: GlobalSuccessLightest
  },
  error: {
    darkest: GlobalErrorDarkest,
    dark: GlobalErrorDark,
    main: GlobalErrorMain,
    light: GlobalErrorLight,
    lightest: GlobalErrorLightest
  }
};

var DrivenBrands;

(function (DrivenBrands) {
  DrivenBrands["AGN"] = "AGN";
  DrivenBrands["DrivenBrands"] = "DrivenBrands";
  DrivenBrands["Take5"] = "Take5";
})(DrivenBrands || (DrivenBrands = {}));

var wellKnownSymbol$2 = wellKnownSymbol$4;

var TO_STRING_TAG$1 = wellKnownSymbol$2('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$c;
var classofRaw = classofRaw$1;
var wellKnownSymbol$1 = wellKnownSymbol$4;

var TO_STRING_TAG = wellKnownSymbol$1('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$2 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var classof$1 = classof$2;

var $String = String;

var toString$3 = function (argument) {
  if (classof$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$4 = anObject$7;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$4(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$3 = fails$d;
var global$3 = global$d;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$3.RegExp;

var UNSUPPORTED_Y$1 = fails$3(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$3(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$3(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var objectDefineProperties = {};

var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$3 = anObject$7;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$3(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$4;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$2 = anObject$7;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$2(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$2 = fails$d;
var global$2 = global$d;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$2.RegExp;

var regexpUnsupportedDotAll = fails$2(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$1 = fails$d;
var global$1 = global$d;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$1.RegExp;

var regexpUnsupportedNcg = fails$1(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$2 = functionCall;
var uncurryThis$2 = functionUncurryThis;
var toString$2 = toString$3;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$2 = uncurryThis$2(''.charAt);
var indexOf = uncurryThis$2(''.indexOf);
var replace = uncurryThis$2(''.replace);
var stringSlice$1 = uncurryThis$2(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$2(nativeExec, re1, 'a');
  call$2(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$2(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$2(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$1(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$2(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$2(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$1(match.input, charsAdded);
        match[0] = stringSlice$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$2(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $ = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$1 = functionUncurryThis;
var defineBuiltIn = defineBuiltIn$2;
var regexpExec$1 = regexpExec$2;
var fails = fails$d;
var wellKnownSymbol = wellKnownSymbol$4;
var createNonEnumerableProperty = createNonEnumerableProperty$3;

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$1(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$1(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis = functionUncurryThis;
var toIntegerOrInfinity = toIntegerOrInfinity$3;
var toString$1 = toString$3;
var requireObjectCoercible$1 = requireObjectCoercible$4;

var charAt$1 = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$1(requireObjectCoercible$1($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var call$1 = functionCall;
var anObject$1 = anObject$7;
var isCallable = isCallable$c;
var classof = classofRaw$1;
var regexpExec = regexpExec$2;

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$1(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$7;
var isNullOrUndefined = isNullOrUndefined$3;
var toLength = toLength$2;
var toString = toString$3;
var requireObjectCoercible = requireObjectCoercible$4;
var getMethod = getMethod$2;
var advanceStringIndex = advanceStringIndex$1;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

const formatLineHeight = lineHeight => {
  if (lineHeight.match('%')) {
    return lineHeight;
  }

  return lineHeight === 'AUTO' ? 'normal' : `${lineHeight}px`;
};

const mapTypography = token => {
  const {
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    lineHeight,
    textCase,
    textDecoration
  } = token;
  const fontProps = {
    fontFamily,
    fontSize: `${fontSize}px`,
    fontWeight: 'normal',
    fontStyle: 'normal'
  };

  switch (fontFamily) {
    // Montserrat for DrivenBrands.com
    case 'Montserrat':
      fontProps.fontFamily = 'MontserratVariable, sans-serif';

      switch (fontWeight) {
        case 'Regular':
          fontProps.fontWeight = 400;
          break;

        case 'Medium':
          fontProps.fontWeight = 500;
          break;

        case 'Bold':
          fontProps.fontWeight = 700;
          break;

        case 'ExtraBold':
          fontProps.fontWeight = 800;
          break;

        case 'ExtraBold Italic':
          fontProps.fontWeight = 800;
          fontProps.fontStyle = 'italic';
          break;
      }

      break;

    case 'Helvetica':
      fontProps.fontFamily = 'Helvetica, Arial, sans-serif';
      fontProps.fontWeight = fontWeight;

      switch (fontWeight) {
        case 'Regular':
          fontProps.fontWeight = 400;
          break;

        case 'Bold':
          fontProps.fontWeight = 700;
          break;

        case 'Bold Oblique':
          fontProps.fontWeight = 700;
          fontProps.fontStyle = 'italic';
          break;

        case 'Light':
          fontProps.fontWeight = 300;
          break;

        case 'Light Oblique':
          fontProps.fontWeight = 300;
          fontProps.fontStyle = 'italic';
          break;

        case 'Oblique':
          fontProps.fontWeight = 400;
          fontProps.fontStyle = 'italic';
          break;
      }

      break;
    // TODO restructure handling of other fonts to match. Leaving mostly as-is right now.

    default:
      switch (fontWeight) {
        case 'Bold':
        case '67 Bold Condensed':
          fontProps.fontWeight = 'bold';
          break;

        case 'Light':
          fontProps.fontWeight = 300;
          break;

        case 'Light Oblique':
          fontProps.fontWeight = 300;
          fontProps.fontStyle = 'oblique';
          break;

        case 'Regular':
        case '57 Condensed':
          fontProps.fontWeight = 'normal';
          break;

        case 'Oblique':
          fontProps.fontWeight = 'normal';
          fontProps.fontStyle = 'oblique';
          break;

        default:
          fontProps.fontWeight = 'normal';
          break;
      }

      break;
  }

  return Object.assign(Object.assign({}, fontProps), {
    letterSpacing: letterSpacing.match('%') ? letterSpacing : `${letterSpacing}px`,
    lineHeight: formatLineHeight(lineHeight),
    textDecoration,
    textTransform: textCase
  });
};

/**
 * Do not edit directly
 * Generated on Tue, 25 Oct 2022 21:31:24 GMT
 */
const DrivenBrandsPrimaryDarkest = '#710c1b';
const DrivenBrandsPrimaryDark = '#a91229';
const DrivenBrandsPrimaryMain = '#e21836';
const DrivenBrandsPrimaryLight = '#e95268';
const DrivenBrandsPrimaryLightest = '#f08b9b';
const DrivenBrandsPrimaryTransparent = '#e218361a';
const DrivenBrandsSecondaryDarkest = '#b89600';
const DrivenBrandsSecondaryDark = '#e0b700';
const DrivenBrandsSecondaryMain = '#ffd000';
const DrivenBrandsSecondaryLight = '#ffe15c';
const DrivenBrandsSecondaryLightest = '#fff0ad';
const DrivenBrandsSecondaryTransparent = '#ffd0001a';
const DrivenBrandsTertiaryDarkest = '#003c4f';
const DrivenBrandsTertiaryDark = '#005a77';
const DrivenBrandsTertiaryMain = '#00789e';
const DrivenBrandsTertiaryLight = '#0099ca';
const DrivenBrandsTertiaryLightest = '#8ce3ff';
const DrivenBrandsTertiaryTransparent = '#00789e1a';
const DrivenBrandsQuaternaryDarkest = '#7d510f';
const DrivenBrandsQuaternaryDark = '#bc7916';
const DrivenBrandsQuaternaryMain = '#faa21e';
const DrivenBrandsQuaternaryLight = '#fbb956';
const DrivenBrandsQuaternaryLightest = '#fdd08e';
const DrivenBrandsQuaternaryTransparent = '#faa21e1a';
const DrivenBrandsFontFamiliesMontserrat = 'Montserrat';
const DrivenBrandsFontFamiliesHelvetica = 'Helvetica';
const DrivenBrandsH1 = {
  fontFamily: 'Montserrat',
  fontWeight: 'Regular',
  lineHeight: '88%',
  fontSize: '80',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsH1Bold = {
  fontFamily: 'Montserrat',
  fontWeight: 'Bold',
  lineHeight: '88%',
  fontSize: '80',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsH2Mh1 = {
  fontFamily: 'Montserrat',
  fontWeight: 'Regular',
  lineHeight: '88%',
  fontSize: '48',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsH2BoldMh1Bold = {
  fontFamily: 'Montserrat',
  fontWeight: 'Bold',
  lineHeight: '88%',
  fontSize: '48',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsH3 = {
  fontFamily: 'Montserrat',
  fontWeight: 'ExtraBold Italic',
  lineHeight: '100%',
  fontSize: '36',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsH4Mh2 = {
  fontFamily: 'Montserrat',
  fontWeight: 'Medium',
  lineHeight: '125%',
  fontSize: '36',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsH5Mh3 = {
  fontFamily: 'Montserrat',
  fontWeight: 'ExtraBold Italic',
  lineHeight: '125%',
  fontSize: '24',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsH6Mh4 = {
  fontFamily: 'Montserrat',
  fontWeight: 'Medium',
  lineHeight: '125%',
  fontSize: '22',
  letterSpacing: '-5%',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsSubtitle1 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '18',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsSubtitle2 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '150%',
  fontSize: '18',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsSubtitle3 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0%',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsBody1 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody1Bold = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody1BoldUnderline = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'underline'
};
const DrivenBrandsBody1Underline = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'underline'
};
const DrivenBrandsBody1Light = {
  fontFamily: 'Helvetica',
  fontWeight: 'Light',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody1LightItalics = {
  fontFamily: 'Helvetica',
  fontWeight: 'Light Oblique',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody2 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody2Bold = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody2BoldUnderline = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'underline'
};
const DrivenBrandsBody2Underline = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'underline'
};
const DrivenBrandsBody2Light = {
  fontFamily: 'Helvetica',
  fontWeight: 'Light',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsBody2LightItalics = {
  fontFamily: 'Helvetica',
  fontWeight: 'Light Oblique',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsCaption = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '150%',
  fontSize: '12',
  letterSpacing: '0%',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsCaptionBold = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '12',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const DrivenBrandsButton = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '16',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const DrivenBrandsButtonSmall = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '150%',
  fontSize: '14',
  letterSpacing: '0',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};

const drivenBrandsTheme = {
  name: 'DrivenBrands',
  palette: Object.assign({
    primary: {
      darkest: DrivenBrandsPrimaryDarkest,
      dark: DrivenBrandsPrimaryDark,
      main: DrivenBrandsPrimaryMain,
      light: DrivenBrandsPrimaryLight,
      lightest: DrivenBrandsPrimaryLightest,
      transparent: DrivenBrandsPrimaryTransparent
    },
    secondary: {
      darkest: DrivenBrandsSecondaryDarkest,
      dark: DrivenBrandsSecondaryDark,
      main: DrivenBrandsSecondaryMain,
      light: DrivenBrandsSecondaryLight,
      lightest: DrivenBrandsSecondaryLightest,
      transparent: DrivenBrandsSecondaryTransparent
    },
    tertiary: {
      darkest: DrivenBrandsTertiaryDarkest,
      dark: DrivenBrandsTertiaryDark,
      main: DrivenBrandsTertiaryMain,
      light: DrivenBrandsTertiaryLight,
      lightest: DrivenBrandsTertiaryLightest,
      transparent: DrivenBrandsTertiaryTransparent
    },
    quaternary: {
      darkest: DrivenBrandsQuaternaryDarkest,
      dark: DrivenBrandsQuaternaryDark,
      main: DrivenBrandsQuaternaryMain,
      light: DrivenBrandsQuaternaryLight,
      lightest: DrivenBrandsQuaternaryLightest,
      transparent: DrivenBrandsQuaternaryTransparent
    }
  }, globalTheme),
  typography: {
    fontFamily: [`"${DrivenBrandsFontFamiliesHelvetica}"`, `"${DrivenBrandsFontFamiliesMontserrat}"`],
    h1: mapTypography(DrivenBrandsH1),
    h1Bold: mapTypography(DrivenBrandsH1Bold),
    h2: mapTypography(DrivenBrandsH2Mh1),
    h2Bold: mapTypography(DrivenBrandsH2BoldMh1Bold),
    h3: mapTypography(DrivenBrandsH3),
    h4: mapTypography(DrivenBrandsH4Mh2),
    h5: mapTypography(DrivenBrandsH5Mh3),
    h6: mapTypography(DrivenBrandsH6Mh4),
    subtitle1: mapTypography(DrivenBrandsSubtitle1),
    subtitle2: mapTypography(DrivenBrandsSubtitle2),
    subtitle3: mapTypography(DrivenBrandsSubtitle3),
    body1: mapTypography(DrivenBrandsBody1),
    body1Bold: mapTypography(DrivenBrandsBody1Bold),
    body1BoldUnderline: mapTypography(DrivenBrandsBody1BoldUnderline),
    body1Underline: mapTypography(DrivenBrandsBody1Underline),
    body1Light: mapTypography(DrivenBrandsBody1Light),
    body1LightItalics: mapTypography(DrivenBrandsBody1LightItalics),
    body2: mapTypography(DrivenBrandsBody2),
    body2Bold: mapTypography(DrivenBrandsBody2Bold),
    body2BoldUnderline: mapTypography(DrivenBrandsBody2BoldUnderline),
    body2Underline: mapTypography(DrivenBrandsBody2Underline),
    body2Light: mapTypography(DrivenBrandsBody2Light),
    body2LightItalics: mapTypography(DrivenBrandsBody2LightItalics),
    caption: mapTypography(DrivenBrandsCaption),
    captionBold: mapTypography(DrivenBrandsCaptionBold),
    button: mapTypography(DrivenBrandsButton),
    smallButton1: mapTypography(DrivenBrandsButtonSmall)
  }
};

/**
 * Do not edit directly
 * Generated on Tue, 25 Oct 2022 21:31:24 GMT
 */
const Take5PrimaryDarkest = '#c7a705';
const Take5PrimaryDark = '#f9d210';
const Take5PrimaryMain = '#fadd4b';
const Take5PrimaryLight = '#fce988';
const Take5PrimaryLightest = '#fdf4c3';
const Take5SecondaryDarkest = '#82160c';
const Take5SecondaryDark = '#a71c0f';
const Take5SecondaryMain = '#c92112';
const Take5SecondaryLight = '#f27a6f';
const Take5SecondaryLightest = '#facac6';
const Take5TertiaryDarkest = '#003c4f';
const Take5TertiaryDark = '#005a77';
const Take5TertiaryMain = '#00789e';
const Take5TertiaryLight = '#0099ca';
const Take5TertiaryLightest = '#8ce3ff';
const Take5ErrorDark = '#a71c0f';
const Take5ErrorMain = '#c92112';
const Take5ErrorLight = '#f27a6f';
const Take5SuccessDarkest = '#19372b';
const Take5SuccessDark = '#275745';
const Take5SuccessMain = '#36785f';
const Take5SuccessLight = '#51b18d';
const Take5SuccessLightest = '#92ceb8';
const Take5FontFamiliesUniversLtStd = 'Univers LT Std';
const Take5TitleH1 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '72',
  fontSize: '60',
  letterSpacing: '-1',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5H2 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '57.6',
  fontSize: '48',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5H3Uppercase = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '48',
  fontSize: '40',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5H3 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: 'AUTO',
  fontSize: '40',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const Take5H4 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '57 Condensed',
  lineHeight: 'AUTO',
  fontSize: '40',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const Take5H5 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: 'AUTO',
  fontSize: '30',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5H6 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '28.6',
  fontSize: '22',
  letterSpacing: '-0.1',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5Subtitle1 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '27',
  fontSize: '18',
  letterSpacing: '0.17',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const Take5Subtitle2 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: 'AUTO',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5Subtitle3 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '57 Condensed',
  lineHeight: '19.2',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const Take5Body1 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '57 Condensed',
  lineHeight: '19.2',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const Take5Body2 = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '19.2',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const Take5Body2Underline = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '19.2',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'underline'
};
const Take5Button = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '28',
  fontSize: '16',
  letterSpacing: '0.4',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const Take5SmallButton = {
  fontFamily: 'Univers LT Std',
  fontWeight: '67 Bold Condensed',
  lineHeight: '22.75',
  fontSize: '13',
  letterSpacing: '0.37',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const Take5Caption = {
  fontFamily: 'Univers LT Std',
  fontWeight: '57 Condensed',
  lineHeight: '16.8',
  fontSize: '14',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};

const take5Theme = {
  name: 'Take5',
  palette: {
    primary: {
      darkest: Take5PrimaryDarkest,
      dark: Take5PrimaryDark,
      main: Take5PrimaryMain,
      light: Take5PrimaryLight,
      lightest: Take5PrimaryLightest,
      contrastText: globalTheme.common.black
    },
    secondary: {
      darkest: Take5SecondaryDarkest,
      dark: Take5SecondaryDark,
      main: Take5SecondaryMain,
      light: Take5SecondaryLight,
      lightest: Take5SecondaryLightest,
      contrastText: globalTheme.common.white
    },
    tertiary: {
      darkest: Take5TertiaryDarkest,
      dark: Take5TertiaryDark,
      main: Take5TertiaryMain,
      light: Take5TertiaryLight,
      lightest: Take5TertiaryLightest,
      contrastText: globalTheme.common.white
    },
    success: {
      darkest: Take5SuccessDarkest,
      dark: Take5SuccessDark,
      main: Take5SuccessMain,
      light: Take5SuccessLight,
      lightest: Take5SuccessLightest,
      contrastText: globalTheme.common.white
    },
    error: {
      dark: Take5ErrorDark,
      main: Take5ErrorMain,
      light: Take5ErrorLight,
      contrastText: globalTheme.common.white
    },
    common: Object.assign({}, globalTheme.common),
    grey: Object.assign({}, globalTheme.grey)
  },
  typography: {
    fontFamily: [`"${Take5FontFamiliesUniversLtStd}"`],
    h1: mapTypography(Take5TitleH1),
    h2: mapTypography(Take5H2),
    h3: mapTypography(Take5H3),
    h3Uppercase: mapTypography(Take5H3Uppercase),
    h4: mapTypography(Take5H4),
    h5: mapTypography(Take5H5),
    h6: mapTypography(Take5H6),
    subtitle1: mapTypography(Take5Subtitle1),
    subtitle2: mapTypography(Take5Subtitle2),
    subtitle3: mapTypography(Take5Subtitle3),
    body1: mapTypography(Take5Body1),
    body2: mapTypography(Take5Body2),
    body2Underline: mapTypography(Take5Body2Underline),
    button: mapTypography(Take5Button),
    smallButton1: mapTypography(Take5SmallButton),
    caption: mapTypography(Take5Caption)
  }
};

const getTheme = brand => {
  switch (brand) {
    case DrivenBrands.Take5:
      return take5Theme;

    case DrivenBrands.DrivenBrands:
      return drivenBrandsTheme;

    default:
      return agnTheme;
  }
};

/**
 * Do not edit directly
 * Generated on Tue, 25 Oct 2022 21:31:24 GMT
 */
const AgnPrimaryDarkest = '#6c140e';
const AgnPrimaryDark = '#a21f15';
const AgnPrimaryMain = '#da291c';
const AgnPrimaryLight = '#ea665d';
const AgnPrimaryLightest = '#f3aaa5';
const AgnSecondaryDarkest = '#b89600';
const AgnSecondaryDark = '#e0b700';
const AgnSecondaryMain = '#ffd000';
const AgnSecondaryLight = '#ffe15c';
const AgnSecondaryLightest = '#fff0ad';
const AgnSuccessDarkest = '#223d1d';
const AgnSuccessDark = '#345c2c';
const AgnSuccessMain = '#457a3b';
const AgnSuccessLight = '#66af59';
const AgnSuccessLightest = '#b2d7ac';
const AgnErrorDarkest = '#6c140e';
const AgnErrorDark = '#a21f15';
const AgnErrorMain = '#da291c';
const AgnErrorLight = '#ea665d';
const AgnErrorLightest = '#f3aaa5';
const AgnFontFamiliesHelvetica = 'Helvetica';
const AgnTitleH1 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '60',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnH2 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '48',
  fontSize: '48',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const AgnH3Uppercase = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '40',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const AgnH3 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '40',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const AgnH4 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Light',
  lineHeight: 'AUTO',
  fontSize: '40',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const AgnH5 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '30',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const AgnH6 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '28',
  fontSize: '22',
  letterSpacing: '-0.1',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const AgnSubtitle1 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '18',
  letterSpacing: '0.17',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const AgnSubtitle2 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const AgnSubtitle3 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: 'AUTO',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnBody = {
  fontFamily: 'Helvetica',
  fontWeight: 'Light',
  lineHeight: '22',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnBody2 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: '24',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnBody2Bold = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '24',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnBody2Italic = {
  fontFamily: 'Helvetica',
  fontWeight: 'Oblique',
  lineHeight: '24',
  fontSize: '16',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnButton = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: '24',
  fontSize: '16',
  letterSpacing: '0.4',
  paragraphSpacing: '0',
  textCase: 'uppercase',
  textDecoration: 'none'
};
const AgnSmallButton1 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Bold',
  lineHeight: 'AUTO',
  fontSize: '13',
  letterSpacing: '0.37',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};
const AgnCaption = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: 'AUTO',
  fontSize: '14',
  letterSpacing: '0.26',
  paragraphSpacing: '0',
  textCase: 'none',
  textDecoration: 'none'
};
const AgnSmallButton2 = {
  fontFamily: 'Helvetica',
  fontWeight: 'Regular',
  lineHeight: 'AUTO',
  fontSize: '13',
  letterSpacing: '0.37',
  paragraphSpacing: '0',
  textCase: 'capitalize',
  textDecoration: 'none'
};

const agnTheme = {
  name: 'AGN',
  palette: {
    primary: {
      darkest: AgnPrimaryDarkest,
      dark: AgnPrimaryDark,
      main: AgnPrimaryMain,
      light: AgnPrimaryLight,
      lightest: AgnPrimaryLightest
    },
    secondary: {
      darkest: AgnSecondaryDarkest,
      dark: AgnSecondaryDark,
      main: AgnSecondaryMain,
      light: AgnSecondaryLight,
      lightest: AgnSecondaryLightest
    },
    tertiary: {
      darkest: AgnSecondaryDarkest,
      dark: AgnSecondaryDark,
      main: AgnSecondaryMain,
      light: AgnSecondaryLight,
      lightest: AgnSecondaryLightest
    },
    success: {
      darkest: AgnSuccessDarkest,
      dark: AgnSuccessDark,
      main: AgnSuccessMain,
      light: AgnSuccessLight,
      lightest: AgnSuccessLightest
    },
    error: {
      darkest: AgnErrorDarkest,
      dark: AgnErrorDark,
      main: AgnErrorMain,
      light: AgnErrorLight,
      lightest: AgnErrorLightest
    },
    common: Object.assign({}, globalTheme.common),
    grey: Object.assign({}, globalTheme.grey)
  },
  typography: {
    fontFamily: [`${AgnFontFamiliesHelvetica}, Arial, sans-serif`],
    h1: mapTypography(AgnTitleH1),
    h2: mapTypography(AgnH2),
    h3: mapTypography(AgnH3),
    h3Uppercase: mapTypography(AgnH3Uppercase),
    h4: mapTypography(AgnH4),
    h5: mapTypography(AgnH5),
    h6: mapTypography(AgnH6),
    subtitle1: mapTypography(AgnSubtitle1),
    subtitle2: mapTypography(AgnSubtitle2),
    subtitle3: mapTypography(AgnSubtitle3),
    body1: mapTypography(AgnBody),
    body2: mapTypography(AgnBody2),
    body2Bold: mapTypography(AgnBody2Bold),
    body2Italic: mapTypography(AgnBody2Italic),
    button: mapTypography(AgnButton),
    smallButton1: mapTypography(AgnSmallButton1),
    smallButton2: mapTypography(AgnSmallButton2),
    caption: mapTypography(AgnCaption)
  }
};

export { DrivenBrands, agnTheme, getTheme, mapTypography, take5Theme };
